import React, { useCallback, useState } from 'react';

import { DeleteOutlined } from '@ant-design/icons';
import ConfirmModal from 'components/ConfirmModal';
import { Button, Typography } from 'ui-kit';

export interface IRemoveCoHostButton {
  coHostId: number;
  onRemove: ({ id }: { id: number }) => void;
}

const RemoveCoHostButton = ({ coHostId, onRemove }: IRemoveCoHostButton) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleRemove = useCallback(() => {
    onRemove({ id: coHostId });
    setIsOpen(false);
  }, [coHostId, onRemove]);

  return (
    <>
      <Button variant="outlined" onClick={() => setIsOpen(true)} size="small">
        <DeleteOutlined />
      </Button>
      <ConfirmModal
        className="ConfirmPropagateModal"
        visible={isOpen}
        onConfirm={handleRemove}
        onCancel={() => setIsOpen(false)}
        confirmText="Delete"
        cancelText="Cancel"
        confirmBtnType="error"
        destroyOnClose
      >
        <Typography className="ConfirmPropagateModal_title" variant="h6">
          Delete co-host
        </Typography>
        <p>
          This will remove the co-host from your profile. They will no longer have access and will
          not be able to manage your stores. This co-host will not receive any future emails.
        </p>
      </ConfirmModal>
    </>
  );
};

export default RemoveCoHostButton;
